<template>
    <!--<div v-html="doc"></div>-->
</template>

<script>
    export default {
      data(){
        return{
          doc:null
        }
      },
      mounted() {
        console.log('ssss');
        var res = window.sessionStorage.getItem("html");
        console.log(res);
        if(res && res.substring(0, 4) == 'http') {
          location.href = res;
        }
        else {
          // this.doc = res;
          var doc = window.document;
          doc.write(res);
          doc.close();
        }

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Charge/Pay.vue